import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";
import { push } from "react-router-redux";
import queryString from "query-string";
import { cloneDeep } from "lodash";
//Semantics
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { Button, Col, Dropdown, Icon, Menu, Row } from "antd";
//actions
import { actions } from "../../../actions/resources";
import { paginators } from "../../../actions/paginator";
import { lists } from "../../../actions/lists";
import {
  // acceptApplicantsUpdatePage,
  addToTeamUpdatePage,
  removeFromTeamUpdatePage
} from "../../../actions/components/dashboard/challenge/admin";
//generic components
import { TableContainer } from "../../generic/paginatedTable";
import { FileDownloader } from "../../generic/FileDownloader";

import StudentsList from "../student/list";
import { Modal } from 'antd';
import { getUser } from "utils/auth";


export class ChallengeAdminPage extends Component {
  state = {
    selectedStudents: []
  };

  limitPerPage = 10;

  shouldComponentUpdate(nextProps) {
    return !!nextProps.challenge;
  }

  componentWillMount() {
    const { match } = this.props;
    if (match.params.id) {
      this._fetchDependencies();
    }
  }

  _fetchDependencies = async () => {
    const { fetchChallenge, fetchTeams } = this.props;
    await fetchChallenge(this.props.match.params.id);

    await fetchTeams({}, this.props.match.params.id);
  };

  _addParticipantToTeam = async (teamId, userId) => {
    const { createUsersTeam, fetchTeams } = this.props;
    await createUsersTeam({
      teamMembers: [
        {
          team_id: teamId,
          user_id: userId
        }
      ]
    });
    await fetchTeams({}, this.props.match.params.id);
  };

  _acceptTeam = async selectedTeams => {
    const {
      challenge,
      updateTeamApplication_accepted
    } = this.props;

    await updateTeamApplication_accepted(challenge.id, {
      team_ids: selectedTeams
    });
    window.location.reload();
  };

  _addTeam = async () => {
    const {
      createTeam,
      challenge,
      fetchPaginatedChallengeParticipants,
      clearChallengeParticipantsPagination
    } = this.props;

    const { order, current_page } = this.props.participantsPagination;

    await createTeam({ challenge_id: challenge.id }, challenge.id);

    //TODO: not clean but only way to reload refresh team list in participants table
    await clearChallengeParticipantsPagination();
    await fetchPaginatedChallengeParticipants(
      this.props.match.params.id,
      current_page || 1,
      {
        order: order || "team_id-asc",
        limit: this.limitPerPage
      }
    );
  };

  _deleteUserFromTeam = async membership => {
    const { deleteUsersTeam, fetchTeams, challenge } = this.props;

    await deleteUsersTeam({
      memberships: [membership],
      challenge_id: challenge.id
    });
    await fetchTeams({}, this.props.match.params.id);
  };

  _ParticipantsTableChange = async (type, { page, sortField, sortOrder }) => {
    const {
      changeChallengeParticipantsExistingPage,
      fetchPaginatedChallengeParticipants,
      clearChallengeParticipantsPagination,
      participantsPagination
    } = this.props;

    // console.log("page", page, "type", type);
    // console.log("participantsPagination", participantsPagination);

    let goToPage = page;

    clearChallengeParticipantsPagination();

    if (type === "pagination") {
      // if (page in participantsPagination) {
      //   changeChallengeParticipantsExistingPage(page);
      // } else {
      await fetchPaginatedChallengeParticipants(
        this.props.match.params.id,
        goToPage,
        {
          order: sortField + "-" + sortOrder,
          limit: this.limitPerPage
        }
      );
      // }
    } else if (type === "sort") {
      // clearChallengeParticipantsPagination();
      goToPage = 1;
      await fetchPaginatedChallengeParticipants(
        this.props.match.params.id,
        goToPage,
        {
          order: sortField + "-" + sortOrder,
          limit: this.limitPerPage
        }
      );
    }
  };

  _inviteTeamMember = async (payload) => {
    const { inviteUserToTeam } = this.props;

    console.log(payload);
    const status = await inviteUserToTeam(payload);

    if (status.canSendInvite) {

      Modal.info({
        title: 'Invite Sent',
        content: status.message
      });

      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      Modal.error({
        title: 'Error',
        content: status.message
      });
    }
  }

  render() {
    const {
      challenge,
      participantsPagination,
      participants,
      teams
    } = this.props;

    if (participants && challenge) {
      return (
        <div className="detail-spacer">
          <div id="challenge-questionnaire-header">
            <Row>
              <Col span={18}>
                <h1 style={{ fontSize: "40px", fontWeight: "bold" }}>
                  Challenge Admin Page
                </h1>
              </Col>
              <Col span={6}>
                <Row type="flex" justify="end">
                  <Link to={`/challenges/`}>
                    <Button type="primary"> Back </Button>
                  </Link>
                </Row>
              </Col>
            </Row>
            <Row>
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  color: "grey"
                }}
              >
                {challenge.name}
              </p>

              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  color: "grey"
                }}
              >
                {queryString.parse(this.props.location.search).company_name}
              </p>
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  color: "grey"
                }}
              >
                {moment(challenge.start_date).format("MM/DD/YYYY")} -{" "}
                {moment(challenge.end_date).format("MM/DD/YYYY")}
              </p>
            </Row>
          </div>
          <div>
            <FileDownloader
              url={process.env.REACT_APP_API_URL + "/challenges/applicants-report/" + challenge.id}
              filename={challenge.name + "_applicants_reports_" + moment(Date.now()).format("MM-DD-YYYY") + ".csv"}
            >
              Download csv
            </FileDownloader>
            {teams.length > 0 ? (
              <Participants
                pagination={participantsPagination}
                teams={teams}
                limit={this.limitPerPage}
                loading={{
                  data: this.props.paginationLoadings.challenges_participant,
                  teams: this.props.collectionLoadings.team
                }}
                data={participants}
                onTableChange={this._ParticipantsTableChange}
                addParticipantToTeam={this._addParticipantToTeam}
                deleteUserFromTeam={this._deleteUserFromTeam}
              />
            ) : null}

            <Teams teams={teams} challenge={challenge} addTeam={this._addTeam} onAcceptTeam={this._acceptTeam} inviteTeamMember={this._inviteTeamMember} />
          </div>
        </div>
      );
    }
    return null;
  }
}

export default connect(
  state => ({
    paginationLoadings: state.paginator.pages.loading,
    collectionLoadings: state.resources.collection.loading,
    DetailLoading: state.resources.detail.loading,
    challenge: state.resources.detail.challenge,
    participants: state.paginator.collection_paginated.challenges_participant || [],
    participantsPagination: state.paginator.pages.challenges_participant || [],
    teams: state.resources.collection.team || []
  }),
  dispatch => ({
    changeChallengeApplicationsExistingPage: bindActionCreators(
      paginators.changeChallengeApplicationsExistingPage,
      dispatch
    ),
    changeChallengeParticipantsExistingPage: bindActionCreators(
      paginators.changeChallengeParticipantsExistingPage,
      dispatch
    ),
    fetchPaginatedChallengeApplications: bindActionCreators(
      paginators.fetchPaginatedChallengeApplications,
      dispatch
    ),
    fetchPaginatedChallengeParticipants: bindActionCreators(
      paginators.fetchPaginatedChallengeParticipants,
      dispatch
    ),
    clearChallengeApplicationsPagination: bindActionCreators(
      paginators.clearChallengeApplicationsPagination,
      dispatch
    ),
    clearChallengeParticipantsPagination: bindActionCreators(
      paginators.clearChallengeParticipantsPagination,
      dispatch
    ),
    createUsersTeam: bindActionCreators(addToTeamUpdatePage, dispatch),
    deleteUsersTeam: bindActionCreators(removeFromTeamUpdatePage, dispatch),
    inviteUserToTeam: bindActionCreators(actions.createAdminInvitation, dispatch),
    createTeam: bindActionCreators(lists.createTeam, dispatch),
    fetchTeams: bindActionCreators(actions.fetchTeams, dispatch),
    updateTeamApplication_accepted: bindActionCreators(lists.patchAndUpdateTeam, dispatch),
    fetchChallenge: bindActionCreators(actions.fetchChallenge, dispatch),
    redirect: bindActionCreators(push, dispatch)
  })
)(ChallengeAdminPage);

class Participants extends Component {
  defaultSorted = [
    {
      dataField: "full_name",
      order: "asc"
    }
  ];

  columns = [
    {
      dataField: "id",
      text: "Id",
      sort: false,
      hidden: true
    },
    {
      dataField: "user_id",
      text: "User Id",
      sort: true,
      hidden: true
    },
    {
      dataField: "full_name",
      text: "Student Name",
      sort: true,
      formatter: cellContent => {
        return cellContent.toLowerCase().replace(/(\s+.)|^\w/gi, function (v) {
          return v.toUpperCase();
        });
      }
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      classes: "overflow-scroll",
      formatter: cellContent => {
        return cellContent.toLowerCase();
      }
    },
    {
      dataField: "university_name",
      text: "University",
      sort: true
    },
    {
      dataField: "created_at",
      text: "Submitted On",
      editable: false,
      sort: true,
      formatter: (cell, row) => {
        return new Date(cell).toLocaleDateString("en-US");
      }
    },
    {
      dataField: "team_id",
      text: "Status",
      sort: true,
      classes: "centered-column",
      headerClasses: "centered-column",
      formatExtraData: [...this.props.teams],
      formatter: (cellContent, row, rowIndex, formatExtraData) => {
        const menu = (
          <Menu
            onClick={({ key }) =>
              this.props.addParticipantToTeam(key, row.user_id)
            }
          >
            {formatExtraData.map(function (team, index) {
              return (
                <Menu.Item key={team.team_id}>
                  <span>{team.team_name}</span>
                </Menu.Item>
              );
            })}
          </Menu>
        );
        if (cellContent) {
          return (
            <strong>
              {row.team_name.split("-")[1]}
              <Icon
                type="close-circle"
                style={{ color: "red", paddingLeft: "15px", cursor: "pointer" }}
                onClick={() =>
                  this.props.deleteUserFromTeam({
                    user_id: row.user_id,
                    team_id: cellContent
                  })
                }
              />
            </strong>
          );
        } else {
          return (
            <div>
              <Dropdown overlay={menu} placement="bottomRight">
                <Button>Assign To Team</Button>
              </Dropdown>
            </div>
          );
        }
      }
    }
  ];

  shouldComponentUpdate(nextProps) {
    const loading = nextProps.loading;
    if (loading.data === undefined || loading.teams === undefined) return false;
    return !(loading.data || loading.teams);
  }

  componentWillUpdate(nextProps) {
    this.columns = cloneDeep(this.columns);
    const index = this.columns.findIndex(
      column => column.dataField === "team_id"
    );
    this.columns[index].formatExtraData = cloneDeep(nextProps.teams);
  }

  render() {
    const { total_items } = this.props.pagination;

    // console.log("Participants", this.props.pagination);

    if (this.props.teams) {
      return (
        <div>
          <TableContainerHeader total_items={total_items} name="Participants" />
          <TableContainer
            pagination={this.props.pagination}
            limit={this.props.limit}
            data={this.props.data}
            columns={this.columns}
            defaultSorted={this.defaultSorted}
            matchKey="id"
            onTableChange={this.props.onTableChange}
          />
          <Row>
            <hr />
          </Row>
        </div>
      );
    }
    return "null";
  }
}

class TableContainerHeader extends Component {
  shouldComponentUpdate(nextProps) {
    return !!nextProps.total_items;
  }

  render() {
    return (
      <Row type="flex" style={{ height: "100px" }} align="middle">
        <Col span={18}>
          <h1 id="header" style={{ color: "#2255ca" }}>
            {this.props.name}
          </h1>
        </Col>
        <Col span={6}>
          <p
            style={{
              fontSize: "15px",
              fontWeight: "bold",
              color: "grey"
            }}
          >
            Total # of {this.props.name} : {this.props.total_items}
          </p>
        </Col>
      </Row>
    );
  }
}

class Teams extends Component {
  selectedTeams = [];

  state = {
    visible: false,
    team_id: 0
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = e => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = e => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  teamsColumns = [
    {
      dataField: "team_name",
      text: "Team Name",
      align: "left",
      headerAlign: "center",
      sort: true,
      formatter: (cell, row) => {
        if (cell) {
          return cell;
        } else {
          return "";
        }
      },
    },
    {
      dataField: "count_members",
      text: "# of members",
      align: "center",
      headerAlign: "center",
      formatter: cellContent => {
        if (cellContent) {
          return cellContent;
        } else {
          return "0";
        }
      },
    },
    {
      dataField: "approved",
      text: "Select to Accept",
      align: "center",
      headerAlign: "center",
      formatter: (cell, row) => {
        if (cell === true) {
          return <strong> Accepted </strong>;
        } else {
          return <input type="checkbox" defaultChecked={false} />;
        }
      }
    },
    {
      dataField: "team_id",
      text: "Invite Members",
      align: "center",
      headerAlign: "center",
      sort: false,
      formatter: (cell, row) => {
        if (cell) {
          // console.log(row);
          if (this.props.challenge.team_size.includes("-")) {
            const teamSize = parseInt(this.props.challenge.team_size.split("-")[1]);
            const currentTeamSize = parseInt(row["count_members"]);
            if (currentTeamSize < teamSize && !row["team_name"].includes('Drop Outs')) {
              return (
                <div>
                  <Button type="primary" style={{ marginRight: "1em" }} onClick={() => this.addToTeam(row["team_id"])}>
                    Add
                  </Button>
                </div>
              );
            }
          }
        }
        return "";
      },
    }
  ];

  addToTeam = (team_id) => {
    this.setState({
      team_id: team_id,
    });
    this.showModal();
  };

  handleAddStudent = async (id) => {
    //console.log(this.props.challenge.id, this.state.team_id, id);

    this.setState({
      visible: false,
    });
    let payload = {
      recipient_id: id,
      team_id: this.state.team_id,
      challenge_id: this.props.challenge.id,
      user_id: getUser().id
    };

    const response = await this.props.inviteTeamMember(payload);

  };

  acceptTeam = () => {
    this.props.onAcceptTeam(this.selectedTeams);
  };

  componentWillUpdate() {
    this.selectedTeams = [];
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.teams.length > 0;
  }

  render() {
    const checkAccepted = {
      onClick: (e, row, rowIndex) => {
        if (e.target.checked) {
          this.selectedTeams.push(row.team_id);
        } else {
          this.selectedTeams = this.selectedTeams.filter(
            item => item !== row.team_id
          );
        }
      }
    };

    if (this.props.teams) {
      return (
        <div>
          <Row type="flex" style={{ height: "100px" }} align="middle">
            <Col span={18}>
              <h1 id="header" style={{ color: "#2255ca" }}>
                Teams
              </h1>

              Team size: {this.props.challenge.team_size}
            </Col>
            <Col span={6}>
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  color: "grey"
                }}
              >
                Total # of Teams : {this.props.teams.length}
              </p>
            </Col>
          </Row>
          <Row>
            <BootstrapTable
              bootstrap4
              keyField="team_id"
              data={this.props.teams}
              columns={this.teamsColumns}
              bordered={false}
              matchKey="team_id"
              rowEvents={checkAccepted}
            />
          </Row>
          <Row
            type="flex"
            justify="center"
            align="middle"
            style={{ height: "100px" }}
          >
            <Button type="primary" onClick={this.props.addTeam}>
              {" "}
              Add Team{" "}
            </Button>
            <Button type="primary" onClick={this.acceptTeam} style={{ marginLeft: "1em" }}>
              Accept Selected
            </Button>
          </Row>
          <Modal
            title="WeSolvers"
            visible={this.state.visible}
            footer={null}
            onCancel={this.handleCancel}
            width="900px"
            height="600px"
            style={{
              top: 0,
              bottom: 80
            }}
          >
            <StudentsList handleAddStudent={this.handleAddStudent} />
          </Modal>
        </div>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/challenge/admin.js